import { map } from 'rxjs';
import { convertUnixToDate } from '@golden/utils';
import { CAMPAIGN_API } from '../CampaignAPI';
export function createCampaignService(api) {
    return {
        getActivityLayoutInfo(activity_id) {
            return api.fetch(CAMPAIGN_API.GET_LAYOUT_INFO, { data: { activity_id } }).pipe(map((data) => ({
                ...convertUnixToDate(data, 'start_at', 'end_at'),
                setting: data.setting
                    ? {
                        ...convertUnixToDate(data.setting, 'start_at', 'end_at'),
                        games: data.setting.games?.map((game) => convertUnixToDate(game, 'start_at', 'end_at', 'game_start_at')) ?? null
                    }
                    : null
            })));
        },
        getActivityLayoutDepositsList(activity_id, game_id) {
            return api.fetch(CAMPAIGN_API.GET_LAYOUT_DEPOSIT_LIST, { data: { activity_id, game_id } }).pipe(map((data) => (data.map((item) => convertUnixToDate(item, 'finished_at')))));
        },
        applyActivityLayout(activity_id, game_id, deposit_id) {
            return api.fetch(CAMPAIGN_API.POST_ACTIVITY_LAYOUT, { data: { activity_id, game_id, deposit_id } });
        },
        cancelApplyActivityLayout(activity_id, game_id) {
            return api.fetch(CAMPAIGN_API.DELETE_ACTIVITY_LAYOUT, { data: { activity_id, game_id } });
        },
        getNewMemberBonus() {
            return api.fetch(CAMPAIGN_API.GET_NEW_MEMBER_BONUS).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at')));
        },
        applyNewMemberBonus() {
            return api.fetch(CAMPAIGN_API.POST_NEW_MEMBER_BONUS);
        },
        refreshNewMemberBonus() {
            return api.fetch(CAMPAIGN_API.POST_NEW_MEMBER_BONUS_PROCESS);
        },
        getRecommendFriendInfo() {
            return api.fetch(CAMPAIGN_API.GET_RECOMMEND_FRIEND_INFO).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at')));
        },
        refreshRecommendFriend() {
            return api.fetch(CAMPAIGN_API.POST_RECOMMEND_FRIEND_PROCESS);
        },
        getHighCashBackInfo() {
            return api.fetch(CAMPAIGN_API.GET_HIGH_CASH_BACK_INFO);
        },
        getRecommendFriendProgress() {
            return api.fetch(CAMPAIGN_API.GET_RECOMMEND_FRIEND).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at')));
        },
        applyRecommendFriend(data) {
            return api.fetch(CAMPAIGN_API.POST_RECOMMEND_FRIEND, { data });
        },
        getInviteFriend(data) {
            return api.fetch(CAMPAIGN_API.GET_INVITE_FRIEND, { data }).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        getInviteFriendRelations() {
            return api.fetch(CAMPAIGN_API.GET_INVITE_FRIEND_RELATIONS).pipe(map((d) => d));
        },
        claimInviteFriendRewards() {
            return api.fetch(CAMPAIGN_API.POST_INVITE_FRIEND_CLAIM_REWARDS);
        },
        getInviteFriendBonus() {
            return api.fetch(CAMPAIGN_API.GET_INVITE_FRIEND_BONUS);
        },
        getInviteFriendQrCode() {
            return api.fetch(CAMPAIGN_API.GET_INVITE_FRIEND_QR_CODE, { config: { responseType: 'blob' } });
        },
        getNewYear2023Info() {
            return api.fetch(CAMPAIGN_API.GET_NEW_YEAR_2023_INFO).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        applyNewYear2023() {
            return api.fetch(CAMPAIGN_API.POST_NEW_YEAR_2023_DRAW);
        },
        getDragonBoatFestival2023Info() {
            return api.fetch(CAMPAIGN_API.GET_DRAGON_BOAT_FESTIVAL_2023).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        applyDragonBoatFestival2023() {
            return api.fetch(CAMPAIGN_API.POST_DRAGON_BOAT_FESTIVAL_2023);
        },
        getNewYear2024Info() {
            return api.fetch(CAMPAIGN_API.GET_NEW_YEAR_2024_INFO).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        getNewYear2024Marquee() {
            return api.fetch(CAMPAIGN_API.GET_NEW_YEAR_2024_MARQUEE);
        },
        applyNewYear2024(deposit_id) {
            return api.fetch(CAMPAIGN_API.POST_NEW_YEAR_2024_DRAW, { data: { deposit_id } });
        },
        getNewYear2024DepositsList() {
            return api.fetch(CAMPAIGN_API.GET_NEW_YEAR_2024_DEPOSIT_LIST).pipe(map((data) => (data.map((item) => convertUnixToDate(item, 'finished_at')))));
        },
        getNewYear2025Info() {
            return api.fetch(CAMPAIGN_API.GET_NEW_YEAR_2025_INFO).pipe(map((data) => ({
                ...convertUnixToDate(data, 'start_at', 'end_at', 'show_start_at', 'show_end_at', 'draw_end_at'),
                draw_records: data.draw_records.map((record) => convertUnixToDate(record, 'time'))
            })));
        },
        applyNewYear2025Draw(category) {
            return api.fetch(CAMPAIGN_API.POST_NEW_YEAR_2025_DRAW, { data: { category } });
        },
        applyNewYear2025ReceiveEnvelope(game_category) {
            return api.fetch(CAMPAIGN_API.POST_NEW_YEAR_2025_RECEIVE_ENVELOPE, { data: { game_category } });
        },
        getNewYearInfo() {
            return api.fetch(CAMPAIGN_API.GET_NEW_YEAR_INFO).pipe(map((data) => ({
                ...convertUnixToDate(data, 'start_at', 'end_at', 'show_start_at', 'show_end_at', 'draw_end_at'),
                draw_records: data.draw_records.map((record) => convertUnixToDate(record, 'time'))
            })));
        },
        applyNewYearDraw(data) {
            return api.fetch(CAMPAIGN_API.POST_NEW_YEAR_DRAW, { data });
        },
        applyNewYearReceiveEnvelope(data) {
            return api.fetch(CAMPAIGN_API.POST_NEW_YEAR_RECEIVE_ENVELOPE, { data });
        },
        getDepositBonus() {
            return api.fetch(CAMPAIGN_API.GET_DEPOSIT_BONUS).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        applyDepositBonus(data) {
            return api.fetch(CAMPAIGN_API.POST_DEPOSIT_BONUS, { data });
        },
        getUefaBuildingUp() {
            return api.fetch(CAMPAIGN_API.GET_UEFA_BUILDING_UP).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        receiveUefaBuildingUp(data) {
            return api.fetch(CAMPAIGN_API.POST_UEFA_BUILDING_UP_RECEIVE, { data });
        },
        applyUefaBuildingUp() {
            return api.fetch(CAMPAIGN_API.POST_UEFA_BUILDING_UP_APPLY);
        },
        getUefaStars() {
            return api.fetch(CAMPAIGN_API.GET_UEFA_STARS).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at', 'show_start_at', 'show_end_at', 'draw_end_at')));
        },
        applyUefaStars() {
            return api.fetch(CAMPAIGN_API.POST_UEFA_STARS);
        },
        buildTeamUefaStars() {
            return api.fetch(CAMPAIGN_API.POST_UEFA_STARS_BUILD);
        },
        getWeeklyBonusGold() {
            return api.fetch(CAMPAIGN_API.GET_WEEKLY_BONUS_GOLD).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        getWeeklyBonusDraw() {
            return api.fetch(CAMPAIGN_API.GET_WEEKLY_BONUS_DRAW).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at', 'show_start_at', 'show_end_at', 'draw_end_at')));
        },
        applyWeeklyBonusDraw() {
            return api.fetch(CAMPAIGN_API.POST_WEEKLY_BONUS_DRAW);
        },
        receiveWeeklyBonusDraw(data) {
            return api.fetch(CAMPAIGN_API.POST_WEEKLY_BONUS_DRAW_RECEIVE, { data });
        },
        getDailyBonusDraw() {
            return api.fetch(CAMPAIGN_API.GET_DAILY_BONUS_DRAW).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at', 'show_start_at', 'show_end_at', 'draw_end_at')));
        },
        applyDailyBonusDraw() {
            return api.fetch(CAMPAIGN_API.POST_DAILY_BONUS_DRAW);
        },
        receiveDailyBonusDraw(data) {
            return api.fetch(CAMPAIGN_API.POST_DAILY_BONUS_DRAW_RECEIVE, { data });
        }
    };
}
//# sourceMappingURL=CampaignService.js.map